export default function Toast({ message, show }) {
    if (!show) return null;

    return (
        <div className="fixed top-20 right-4 z-[999] bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg animate-bounce">
            ✅ {message}
        </div>
    );
}
